import "core-js/modules/es.array.every";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.object.values";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getStationDailyCounters, getBillListData } from '@/api/bairun/financialCenter';
import { mapGetters } from 'vuex';
import NP from 'number-precision';
import moment from 'moment';
import dateUtils from '@/utils/dateUtil';
import stationUtils from '@/utils/station';
export default {
  name: 'FinancialOil',
  data: function data() {
    var _this = this;

    return {
      data: {},
      billStart: 0,
      billEnd: 0,
      slotT: 50,
      slotMapping: stationUtils.getOrderGoodsTitleMaps(),
      datePickerValue: [(dateUtils.todayTimestamp() - 7 * 24 * 60 * 60) * 1000, (dateUtils.todayTimestamp() - 24 * 60 * 60) * 1000],
      sheetUnLoadCount: 1,
      downloadLoading: false,
      downloadBillLoading: false,
      stationDailyReportData: [],
      stationMonthTotalData: [],
      excelSheets: [{
        tableId: 'stationDailyReportData',
        name: '油站日报表',
        tableRows: 4
      }, {
        tableId: 'stationMonthTotalData',
        name: '本月实收统计',
        tableRows: 2
      }],
      selectedStation: {
        'ID': 0,
        'stationName': '',
        'statTag': '选择站点',
        'statAbbr': '',
        'appId': 'aaa'
      },
      pickerOptionsLimit: {
        disabledDate: function disabledDate(pTime) {
          return _this.userInfo.authorityId === '888' ? false : pTime.getTime() < new Date() - 92 * 86400 * 1000 || pTime.getTime() > new Date() - 86400 * 1000;
        }
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('user', ['userInfo'])), mapGetters('stations', ['asyncStations'])),
  watch: {
    datePickerValue: function datePickerValue() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$refs['stationDailyReportData'].doLayout();

        _this2.$refs['stationMonthTotalData'].doLayout(); // console.log('refsUpdate')

      }); // this.loadData()
    }
  },
  created: function created() {
    var _this3 = this;

    this.$nextTick(function () {
      _this3.$refs['stationDailyReportData'].doLayout();

      _this3.$refs['stationMonthTotalData'].doLayout(); // console.log('refsUpdate')

    });
  },
  updated: function updated() {
    var _this4 = this;

    this.$nextTick(function () {
      _this4.$refs['stationDailyReportData'].doLayout();

      _this4.$refs['stationMonthTotalData'].doLayout(); // console.log('refsUpdate')

    });
  },
  methods: {
    numberFix: function numberFix(number, len) {
      return dateUtils.numberFix(number, len);
    },
    npPlus: function npPlus() {
      var res = 0;

      for (var i in arguments) {
        res = arguments[i] !== undefined ? NP.plus(res, arguments[i]) : res;
      }

      return res;
    },
    npMinus: function npMinus() {
      var res = arguments[0];

      for (var i in arguments) {
        res = arguments[i] !== undefined && i > 0 ? NP.minus(res, arguments[i]) : res;
      }

      return res;
    },
    amountFormat: function amountFormat(value) {
      return NP.round(value, 2);
    },
    npPlusArr: function npPlusArr(arr) {
      var res = 0;

      for (var i in arr) {
        // // console.log('arr', i, arr.length, arr[i], Number(arr[i]))
        res = NP.plus(res, Number(arr[i]));
      }

      return res;
    },
    getSummaries: function getSummaries(param) {
      var _this5 = this;

      var columns = param.columns,
          data = param.data;
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }

        var values;

        if (column.property === 'dailyCashDeposit.depositValue') {
          values = data.map(function (item) {
            return Number(item['dailyCashDeposit']['depositValue']);
          });
        } else if (column.property === 'dailyCashDeposit.depositLeftValue') {
          values = data.map(function (item) {
            return Number(item['dailyCashDeposit']['depositLeftValue']);
          });
        } else if (column.property === 'selfDiscount') {
          values = data.map(function (item) {
            return item['xwlCapitalDiscount'] ? NP.minus(Number(item['selfDiscount']), Number(item['xwlCapitalDiscount'])) : Number(item['selfDiscount']);
          });
        } else {
          values = data.map(function (item) {
            return Number(item[column.property]);
          });
        }

        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);

            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = _this5.numberFix(sums[index], 2);
        } else {
          sums[index] = 'N/A';
        }
      });
      return sums;
    },
    getSummaries2: function getSummaries2(param) {
      var _this6 = this;

      var columns = param.columns,
          data = param.data;
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '实收金额';
          return;
        }

        var values = data.map(function (item) {
          return item['code'] === 'item_total' && column.property.indexOf('discount') === 0 ? -Number(item[column.property]) : item['code'] === 'item_return' && column.property.indexOf('discount') === 0 ? Number(item[column.property]) : item['code'] === 'item_original' ? Number(item[column.property]) : 0;
        });

        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);

            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = _this6.numberFix(sums[index], 2);
        } else {
          sums[index] = 'N/A';
        }
      });
      return sums;
    },
    loadData: function loadData() {
      var _this7 = this;

      if (this.downloadLoading) {
        return;
      }

      if (this.selectedStation.ID === 0) {
        _Message({
          message: '请选择对应的站点',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      this.billStart = 0;
      this.billEnd = 0;
      this.downloadLoading = true;
      getStationDailyCounters({
        appId: this.selectedStation.appId,
        sellerId: this.selectedStation.ID,
        startDate: moment(this.datePickerValue[0]).format('YYYYMMDD'),
        endDate: moment(this.datePickerValue[1]).format('YYYYMMDD')
      }).then(function (response) {
        // // console.log('getStationDailyDiff', response)
        _this7.stationDailyReportData = response.data;
        var totalItem = {
          'item_original': {
            title: '国家价小计',
            code: 'item_original',
            nums0: 0,
            total0: 0,
            discount0: 0,
            amount0: 0,
            nums92: 0,
            total92: 0,
            discount92: 0,
            amount92: 0,
            nums95: 0,
            total95: 0,
            discount95: 0,
            amount95: 0,
            nums: 0,
            total: 0,
            discount: 0,
            amount: 0
          },
          'item_station': {
            title: '油站小计',
            code: 'item_station',
            nums0: 0,
            total0: 0,
            discount0: 0,
            amount0: 0,
            nums92: 0,
            total92: 0,
            discount92: 0,
            amount92: 0,
            nums95: 0,
            total95: 0,
            discount95: 0,
            amount95: 0,
            nums: 0,
            total: 0,
            discount: 0,
            amount: 0
          },
          'item_2002': {
            title: '货车帮',
            code: 'item_2002',
            nums0: 0,
            total0: 0,
            discount0: 0,
            amount0: 0,
            nums92: 0,
            total92: 0,
            discount92: 0,
            amount92: 0,
            nums95: 0,
            total95: 0,
            discount95: 0,
            amount95: 0,
            nums: 0,
            total: 0,
            discount: 0,
            amount: 0
          },
          'item_2001': {
            title: '滴滴',
            code: 'item_2001',
            nums0: 0,
            total0: 0,
            discount0: 0,
            amount0: 0,
            nums92: 0,
            total92: 0,
            discount92: 0,
            amount92: 0,
            nums95: 0,
            total95: 0,
            discount95: 0,
            amount95: 0,
            nums: 0,
            total: 0,
            discount: 0,
            amount: 0
          },
          'item_2004': {
            title: '团油',
            code: 'item_2004',
            nums0: 0,
            total0: 0,
            discount0: 0,
            amount0: 0,
            nums92: 0,
            total92: 0,
            discount92: 0,
            amount92: 0,
            nums95: 0,
            total95: 0,
            discount95: 0,
            amount95: 0,
            nums: 0,
            total: 0,
            discount: 0,
            amount: 0
          },
          'item_2013': {
            title: '团油车队',
            code: 'item_2013',
            nums0: 0,
            total0: 0,
            discount0: 0,
            amount0: 0,
            nums92: 0,
            total92: 0,
            discount92: 0,
            amount92: 0,
            nums95: 0,
            total95: 0,
            discount95: 0,
            amount95: 0,
            nums: 0,
            total: 0,
            discount: 0,
            amount: 0
          },
          'item_2014': {
            title: '鲸车惠',
            code: 'item_2014',
            nums0: 0,
            total0: 0,
            discount0: 0,
            amount0: 0,
            nums92: 0,
            total92: 0,
            discount92: 0,
            amount92: 0,
            nums95: 0,
            total95: 0,
            discount95: 0,
            amount95: 0,
            nums: 0,
            total: 0,
            discount: 0,
            amount: 0
          },
          'item_2011': {
            title: '佰思达',
            code: 'item_2011',
            nums0: 0,
            total0: 0,
            discount0: 0,
            amount0: 0,
            nums92: 0,
            total92: 0,
            discount92: 0,
            amount92: 0,
            nums95: 0,
            total95: 0,
            discount95: 0,
            amount95: 0,
            nums: 0,
            total: 0,
            discount: 0,
            amount: 0
          },
          'item_1008': {
            title: '支付宝',
            code: 'item_1008',
            nums0: 0,
            total0: 0,
            discount0: 0,
            amount0: 0,
            nums92: 0,
            total92: 0,
            discount92: 0,
            amount92: 0,
            nums95: 0,
            total95: 0,
            discount95: 0,
            amount95: 0,
            nums: 0,
            total: 0,
            discount: 0,
            amount: 0
          },
          'item_2007': {
            title: '嗨卡',
            code: 'item_2007',
            nums0: 0,
            total0: 0,
            discount0: 0,
            amount0: 0,
            nums92: 0,
            total92: 0,
            discount92: 0,
            amount92: 0,
            nums95: 0,
            total95: 0,
            discount95: 0,
            amount95: 0,
            nums: 0,
            total: 0,
            discount: 0,
            amount: 0
          },
          'item_2012': {
            title: '爱车',
            code: 'item_2012',
            nums0: 0,
            total0: 0,
            discount0: 0,
            amount0: 0,
            nums92: 0,
            total92: 0,
            discount92: 0,
            amount92: 0,
            nums95: 0,
            total95: 0,
            discount95: 0,
            amount95: 0,
            nums: 0,
            total: 0,
            discount: 0,
            amount: 0
          },
          'item_2009': {
            title: '途虎',
            code: 'item_2009',
            nums0: 0,
            total0: 0,
            discount0: 0,
            amount0: 0,
            nums92: 0,
            total92: 0,
            discount92: 0,
            amount92: 0,
            nums95: 0,
            total95: 0,
            discount95: 0,
            amount95: 0,
            nums: 0,
            total: 0,
            discount: 0,
            amount: 0
          },
          'item_2003': {
            title: '易加油',
            code: 'item_2003',
            nums0: 0,
            total0: 0,
            discount0: 0,
            amount0: 0,
            nums92: 0,
            total92: 0,
            discount92: 0,
            amount92: 0,
            nums95: 0,
            total95: 0,
            discount95: 0,
            amount95: 0,
            nums: 0,
            total: 0,
            discount: 0,
            amount: 0
          },
          'item_platform': {
            title: '平台小计',
            code: 'item_platform',
            nums0: 0,
            total0: 0,
            discount0: 0,
            amount0: 0,
            nums92: 0,
            total92: 0,
            discount92: 0,
            amount92: 0,
            nums95: 0,
            total95: 0,
            discount95: 0,
            amount95: 0,
            nums: 0,
            total: 0,
            discount: 0,
            amount: 0
          },
          'item_svc': {
            title: '储值卡',
            code: 'item_svc',
            nums0: 0,
            total0: 0,
            discount0: 0,
            amount0: 0,
            nums92: 0,
            total92: 0,
            discount92: 0,
            amount92: 0,
            nums95: 0,
            total95: 0,
            discount95: 0,
            amount95: 0,
            nums: 0,
            total: 0,
            discount: 0,
            amount: 0
          },
          'item_online': {
            title: '点付',
            code: 'item_online',
            nums0: 0,
            total0: 0,
            discount0: 0,
            amount0: 0,
            nums92: 0,
            total92: 0,
            discount92: 0,
            amount92: 0,
            nums95: 0,
            total95: 0,
            discount95: 0,
            amount95: 0,
            nums: 0,
            total: 0,
            discount: 0,
            amount: 0
          },
          'item_cash': {
            title: '现金',
            code: 'item_cash',
            nums0: 0,
            total0: 0,
            discount0: 0,
            amount0: 0,
            nums92: 0,
            total92: 0,
            discount92: 0,
            amount92: 0,
            nums95: 0,
            total95: 0,
            discount95: 0,
            amount95: 0,
            nums: 0,
            total: 0,
            discount: 0,
            amount: 0
          },
          'item_self': {
            title: '自营小计',
            code: 'item_self',
            nums0: 0,
            total0: 0,
            discount0: 0,
            amount0: 0,
            nums92: 0,
            total92: 0,
            discount92: 0,
            amount92: 0,
            nums95: 0,
            total95: 0,
            discount95: 0,
            amount95: 0,
            nums: 0,
            total: 0,
            discount: 0,
            amount: 0
          }
        };
        _this7.downloadLoading = false;

        if (_this7.stationDailyReportData.length > 0) {
          _this7.billStart = moment(_this7.stationDailyReportData[0]['startDate']).unix();
          _this7.billEnd = moment(_this7.stationDailyReportData[_this7.stationDailyReportData.length - 1]['endDate']).unix();
          _this7.sheetUnLoadCount = 0;

          _this7.stationDailyReportData.forEach(function (row) {
            var elRow = row;
            elRow.diesel0Nums = 0;
            elRow.diesel0Amount = 0;
            elRow.petrol92Nums = 0;
            elRow.petrol92Amount = 0;
            elRow.petrol95Nums = 0;
            elRow.petrol95Amount = 0;
            elRow.oilNums = 0;
            elRow.oilAmount = 0; // 油品回罐升数

            elRow.oilReturnNums = 0;
            elRow.oilReturnAmount = 0; // 油品自用升数

            elRow.oilWarnNums = 0;
            elRow.oilWarnAmount = 0; // 油品异常升数

            elRow.oilWarnNums = 0;
            elRow.oilWarnAmount = 0; // 油品销量升数

            elRow.oilSaleNums = 0;
            elRow.oilSaleAmount = 0;

            if (row.dailyGoodsData.length > 0) {
              row.dailyGoodsData.forEach(function (el) {
                if (el.sellerOrderType === 4) {
                  return;
                }

                if (el.goodsSpu === '0') {
                  // 柴油
                  elRow.diesel0Nums = el.goodsNums;
                  elRow.diesel0Amount = el.payablesAmount;
                  totalItem['item_original']['nums0'] = NP.plus(totalItem['item_original']['nums0'], el.goodsNums);
                  totalItem['item_original']['amount0'] = NP.plus(totalItem['item_original']['discount0'], el.payablesAmount);
                  totalItem['item_original']['discount0'] = 0;
                  totalItem['item_original']['total0'] = NP.plus(totalItem['item_original']['discount0'], el.payablesAmount);
                  totalItem['item_station']['nums0'] = NP.plus(totalItem['item_station']['nums0'], el.goodsNums);
                  totalItem['item_station']['total0'] = NP.plus(totalItem['item_station']['amount0'], el.payablesAmount);
                  totalItem['item_station']['discount0'] = NP.plus(totalItem['item_station']['discount0'], el.sumOnlineDiscount, el.sumSvcDiscount, el.sumCashDiscount, el.sumPlatformDiscount);
                  totalItem['item_station']['amount0'] = NP.minus(totalItem['item_station']['total0'], totalItem['item_station']['discount0']);
                  totalItem['item_online']['nums0'] = NP.plus(totalItem['item_online']['nums0'], el.sumOnlineNums);
                  totalItem['item_online']['discount0'] = NP.plus(totalItem['item_online']['discount0'], el.sumOnlineDiscount);
                  totalItem['item_online']['amount0'] = NP.plus(totalItem['item_online']['amount0'], el.sumOnlineAmount);
                  totalItem['item_online']['total0'] = NP.plus(totalItem['item_online']['amount0'], totalItem['item_online']['discount0']);
                  totalItem['item_svc']['nums0'] = NP.plus(totalItem['item_svc']['nums0'], el.sumSvcNums);
                  totalItem['item_svc']['amount0'] = NP.plus(totalItem['item_svc']['amount0'], el.sumSvcAmount);
                  totalItem['item_svc']['discount0'] = NP.plus(totalItem['item_svc']['discount0'], el.sumSvcDiscount);
                  totalItem['item_svc']['total0'] = NP.plus(totalItem['item_svc']['amount0'], totalItem['item_svc']['discount0']);
                  totalItem['item_cash']['nums0'] = NP.plus(totalItem['item_cash']['nums0'], el.sumCashNums);
                  totalItem['item_cash']['amount0'] = NP.plus(totalItem['item_cash']['amount0'], el.sumCashAmount);
                  totalItem['item_cash']['discount0'] = NP.plus(totalItem['item_cash']['discount0'], el.sumCashDiscount);
                  totalItem['item_cash']['total0'] = NP.plus(totalItem['item_cash']['amount0'], totalItem['item_cash']['discount0']); // if (el.goodsOriginal > el.goodsPrice) {
                  //   console.log('0# item_station', el.dailyDate, el.goodsNums)
                  // }
                } else if (el.goodsSpu === '92') {
                  // 汽油 92
                  elRow.petrol92Nums = el.goodsNums;
                  elRow.petrol92Amount = el.payablesAmount;
                  totalItem['item_original']['nums92'] = NP.plus(totalItem['item_original']['nums92'], el.goodsNums);
                  totalItem['item_original']['total92'] = NP.plus(totalItem['item_original']['discount92'], el.payablesAmount);
                  totalItem['item_original']['discount92'] = 0;
                  totalItem['item_original']['amount92'] = NP.plus(totalItem['item_original']['discount92'], el.payablesAmount);
                  totalItem['item_station']['nums92'] = NP.plus(totalItem['item_station']['nums92'], el.goodsNums);
                  totalItem['item_station']['total92'] = NP.plus(totalItem['item_station']['total92'], el.payablesAmount);
                  totalItem['item_station']['discount92'] = NP.plus(totalItem['item_station']['discount92'], el.sumOnlineDiscount, el.sumSvcDiscount, el.sumCashDiscount, el.sumPlatformDiscount);
                  totalItem['item_station']['amount92'] = NP.minus(totalItem['item_station']['total92'], totalItem['item_station']['discount92']);
                  totalItem['item_online']['nums92'] = NP.plus(totalItem['item_online']['nums92'], el.sumOnlineNums);
                  totalItem['item_online']['discount92'] = NP.plus(totalItem['item_online']['discount92'], el.sumOnlineDiscount);
                  totalItem['item_online']['amount92'] = NP.plus(totalItem['item_online']['amount92'], el.sumOnlineAmount);
                  totalItem['item_online']['total92'] = NP.plus(totalItem['item_online']['amount92'], totalItem['item_online']['discount92']);
                  totalItem['item_svc']['nums92'] = NP.plus(totalItem['item_svc']['nums92'], el.sumSvcNums);
                  totalItem['item_svc']['amount92'] = NP.plus(totalItem['item_svc']['amount92'], el.sumSvcAmount);
                  totalItem['item_svc']['discount92'] = NP.plus(totalItem['item_svc']['discount92'], el.sumSvcDiscount);
                  totalItem['item_svc']['total92'] = NP.plus(totalItem['item_svc']['amount92'], totalItem['item_svc']['discount92']);
                  totalItem['item_cash']['nums92'] = NP.plus(totalItem['item_cash']['nums92'], el.sumCashNums);
                  totalItem['item_cash']['amount92'] = NP.plus(totalItem['item_cash']['amount92'], el.sumCashAmount);
                  totalItem['item_cash']['discount92'] = NP.plus(totalItem['item_cash']['discount92'], el.sumCashDiscount);
                  totalItem['item_cash']['total92'] = NP.plus(totalItem['item_cash']['amount92'], totalItem['item_cash']['discount92']);
                } else if (el.goodsSpu === '95') {
                  // 汽油 95
                  elRow.petrol95Nums = el.goodsNums;
                  elRow.petrol95Amount = el.payablesAmount;
                  totalItem['item_original']['nums95'] = NP.plus(totalItem['item_original']['nums95'], el.goodsNums);
                  totalItem['item_original']['total95'] = NP.plus(totalItem['item_original']['discount95'], el.payablesAmount);
                  totalItem['item_original']['discount95'] = 0;
                  totalItem['item_original']['amount95'] = NP.plus(totalItem['item_original']['discount95'], el.payablesAmount);
                  totalItem['item_station']['nums95'] = NP.plus(totalItem['item_station']['nums95'], el.goodsNums);
                  totalItem['item_station']['total95'] = NP.plus(totalItem['item_station']['total95'], el.payablesAmount);
                  totalItem['item_station']['discount95'] = NP.plus(totalItem['item_station']['discount95'], el.sumOnlineDiscount, el.sumSvcDiscount, el.sumCashDiscount, el.sumPlatformDiscount);
                  totalItem['item_station']['amount95'] = NP.minus(totalItem['item_station']['total95'], totalItem['item_station']['discount95']);
                  totalItem['item_online']['nums95'] = NP.plus(totalItem['item_online']['nums95'], el.sumOnlineNums);
                  totalItem['item_online']['discount95'] = NP.plus(totalItem['item_online']['discount95'], el.sumOnlineDiscount);
                  totalItem['item_online']['amount95'] = NP.plus(totalItem['item_online']['amount95'], el.sumOnlineAmount);
                  totalItem['item_online']['total95'] = NP.plus(totalItem['item_online']['amount95'], totalItem['item_online']['discount95']);
                  totalItem['item_svc']['nums95'] = NP.plus(totalItem['item_svc']['nums95'], el.sumSvcNums);
                  totalItem['item_svc']['amount95'] = NP.plus(totalItem['item_svc']['amount95'], el.sumSvcAmount);
                  totalItem['item_svc']['discount95'] = NP.plus(totalItem['item_svc']['discount95'], el.sumSvcDiscount);
                  totalItem['item_svc']['total95'] = NP.plus(totalItem['item_svc']['amount95'], totalItem['item_svc']['discount95']);
                  totalItem['item_cash']['nums95'] = NP.plus(totalItem['item_cash']['nums95'], el.sumCashNums);
                  totalItem['item_cash']['amount95'] = NP.plus(totalItem['item_cash']['amount95'], el.sumCashAmount);
                  totalItem['item_cash']['discount95'] = NP.plus(totalItem['item_cash']['discount95'], el.sumCashDiscount);
                  totalItem['item_cash']['total95'] = NP.plus(totalItem['item_cash']['amount95'], totalItem['item_cash']['discount95']);
                }

                if (el.sellerOrderType === 1) {
                  totalItem['item_original']['nums'] = NP.plus(totalItem['item_original']['nums0'], totalItem['item_original']['nums92'], totalItem['item_original']['nums95']);
                  totalItem['item_original']['total'] = NP.plus(totalItem['item_original']['total0'], totalItem['item_original']['total92'], totalItem['item_original']['total95']);
                  totalItem['item_original']['discount'] = NP.plus(totalItem['item_original']['discount0'], totalItem['item_original']['discount92'], totalItem['item_original']['discount95']);
                  totalItem['item_original']['amount'] = NP.plus(totalItem['item_original']['amount0'], totalItem['item_original']['amount92'], totalItem['item_original']['amount95']);
                  totalItem['item_station']['nums'] = NP.plus(totalItem['item_station']['nums0'], totalItem['item_station']['nums92'], totalItem['item_station']['nums95']);
                  totalItem['item_station']['total'] = NP.plus(totalItem['item_station']['total0'], totalItem['item_station']['total92'], totalItem['item_station']['total95']);
                  totalItem['item_station']['discount'] = NP.plus(totalItem['item_station']['discount0'], totalItem['item_station']['discount92'], totalItem['item_station']['discount95']);
                  totalItem['item_station']['amount'] = NP.plus(totalItem['item_station']['amount0'], totalItem['item_station']['amount92'], totalItem['item_station']['amount95']);
                  totalItem['item_online']['nums'] = NP.plus(totalItem['item_online']['nums0'], totalItem['item_online']['nums92'], totalItem['item_online']['nums95']);
                  totalItem['item_online']['total'] = NP.plus(totalItem['item_online']['total0'], totalItem['item_online']['total92'], totalItem['item_online']['total95']);
                  totalItem['item_online']['discount'] = NP.plus(totalItem['item_online']['discount0'], totalItem['item_online']['discount92'], totalItem['item_online']['discount95']);
                  totalItem['item_online']['amount'] = NP.plus(totalItem['item_online']['amount0'], totalItem['item_online']['amount92'], totalItem['item_online']['amount95']);
                  totalItem['item_svc']['nums'] = NP.plus(totalItem['item_svc']['nums0'], totalItem['item_svc']['nums92'], totalItem['item_svc']['nums95']);
                  totalItem['item_svc']['total'] = NP.plus(totalItem['item_svc']['total0'], totalItem['item_svc']['total92'], totalItem['item_svc']['total95']);
                  totalItem['item_svc']['discount'] = NP.plus(totalItem['item_svc']['discount0'], totalItem['item_svc']['discount92'], totalItem['item_svc']['discount95']);
                  totalItem['item_svc']['amount'] = NP.plus(totalItem['item_svc']['amount0'], totalItem['item_svc']['amount92'], totalItem['item_svc']['amount95']);
                  totalItem['item_cash']['nums'] = NP.plus(totalItem['item_cash']['nums0'], totalItem['item_cash']['nums92'], totalItem['item_cash']['nums95']);
                  totalItem['item_cash']['total'] = NP.plus(totalItem['item_cash']['total0'], totalItem['item_cash']['total92'], totalItem['item_cash']['total95']);
                  totalItem['item_cash']['discount'] = NP.plus(totalItem['item_cash']['discount0'], totalItem['item_cash']['discount92'], totalItem['item_cash']['discount95']);
                  totalItem['item_cash']['amount'] = NP.plus(totalItem['item_cash']['amount0'], totalItem['item_cash']['amount92'], totalItem['item_cash']['amount95']);
                } // 油品油机升数


                elRow.oilNums = elRow.oilNums !== undefined ? NP.plus(elRow.oilNums, el.goodsNums) : el.goodsNums;
                elRow.oilAmount = elRow.oilAmount !== undefined ? NP.plus(elRow.oilAmount, el.payablesAmount) : el.payablesAmount; // 油品回罐升数

                elRow.oilReturnNums = elRow.oilReturnNums !== undefined ? NP.plus(elRow.oilReturnNums, el.returnGoodsNums) : el.returnGoodsNums;
                elRow.oilReturnAmount = elRow.oilReturnAmount !== undefined ? NP.plus(elRow.oilReturnAmount, el.returnPayablesAmount) : el.returnPayablesAmount; // 油品自用升数

                elRow.oilWarnNums = elRow.oilWarnNums !== undefined ? NP.plus(elRow.oilWarnNums, el.selfGoodsNums) : el.selfGoodsNums;
                elRow.oilWarnAmount = elRow.oilWarnAmount !== undefined ? NP.plus(elRow.oilWarnAmount, el.selfPayablesAmount) : el.selfPayablesAmount; // 油品异常升数

                elRow.oilWarnNums = elRow.oilWarnNums !== undefined ? NP.plus(elRow.oilWarnNums, el.warnGoodsNums) : el.warnGoodsNums;
                elRow.oilWarnAmount = elRow.oilWarnAmount !== undefined ? NP.plus(elRow.oilWarnAmount, el.warnPayablesAmount) : el.warnPayablesAmount; // 油品销量升数

                elRow.oilSaleNums = NP.minus(elRow.oilNums, elRow.oilReturnNums, elRow.oilWarnNums);
                elRow.oilSaleAmount = NP.minus(elRow.oilAmount, elRow.oilReturnAmount, elRow.oilWarnAmount); // 优惠

                elRow.selfDiscount = elRow.selfDiscount !== undefined ? NP.plus(elRow.selfDiscount, el.discountAmount) : el.discountAmount;
                elRow.tradeDiscount = elRow.tradeDiscount !== undefined ? NP.plus(elRow.tradeDiscount, el.tradeDiscount) : el.tradeDiscount;
              });
            }

            if (row.dailyPlatformData.length > 0) {
              row.dailyPlatformData.forEach(function (el3) {
                var itemIndex = 'item_' + el3['platform'];

                if (!totalItem[itemIndex] || totalItem[itemIndex] === undefined) {
                  return;
                }

                totalItem[itemIndex]['nums0'] = NP.plus(totalItem[itemIndex]['nums0'], el3.nums0);
                totalItem[itemIndex]['total0'] = NP.plus(totalItem[itemIndex]['total0'], el3.total0);
                totalItem[itemIndex]['discount0'] = NP.plus(totalItem[itemIndex]['discount0'], el3.discount0);
                totalItem[itemIndex]['amount0'] = NP.plus(totalItem[itemIndex]['amount0'], el3.amount0);
                totalItem[itemIndex]['nums92'] = NP.plus(totalItem[itemIndex]['nums92'], el3.nums92);
                totalItem[itemIndex]['total92'] = NP.plus(totalItem[itemIndex]['total92'], el3.total92);
                totalItem[itemIndex]['discount92'] = NP.plus(totalItem[itemIndex]['discount92'], el3.discount92);
                totalItem[itemIndex]['amount92'] = NP.plus(totalItem[itemIndex]['amount92'], el3.amount92);
                totalItem[itemIndex]['nums95'] = NP.plus(totalItem[itemIndex]['nums95'], el3.nums95);
                totalItem[itemIndex]['total95'] = NP.plus(totalItem[itemIndex]['total95'], el3.total95);
                totalItem[itemIndex]['discount95'] = NP.plus(totalItem[itemIndex]['discount95'], el3.discount95);
                totalItem[itemIndex]['amount95'] = NP.plus(totalItem[itemIndex]['amount95'], el3.amount95);
                totalItem[itemIndex]['nums'] = NP.plus(totalItem[itemIndex]['nums95'], totalItem[itemIndex]['nums92'], totalItem[itemIndex]['nums0']);
                totalItem[itemIndex]['total'] = NP.plus(totalItem[itemIndex]['total95'], totalItem[itemIndex]['total92'], totalItem[itemIndex]['total0']);
                totalItem[itemIndex]['discount'] = NP.plus(totalItem[itemIndex]['discount95'], totalItem[itemIndex]['discount92'], totalItem[itemIndex]['discount0']);
                totalItem[itemIndex]['amount'] = NP.plus(totalItem[itemIndex]['amount95'], totalItem[itemIndex]['amount92'], totalItem[itemIndex]['amount0']);
                totalItem['item_platform']['nums0'] = NP.plus(totalItem['item_platform']['nums0'], el3.nums0);
                totalItem['item_platform']['total0'] = NP.plus(totalItem['item_platform']['total0'], el3.total0);
                totalItem['item_platform']['discount0'] = NP.plus(totalItem['item_platform']['discount0'], el3.discount0);
                totalItem['item_platform']['amount0'] = NP.plus(totalItem['item_platform']['amount0'], el3.amount0);
                totalItem['item_platform']['nums92'] = NP.plus(totalItem['item_platform']['nums92'], el3.nums92);
                totalItem['item_platform']['total92'] = NP.plus(totalItem['item_platform']['total92'], el3.total92);
                totalItem['item_platform']['discount92'] = NP.plus(totalItem['item_platform']['discount92'], el3.discount92);
                totalItem['item_platform']['amount92'] = NP.plus(totalItem['item_platform']['amount92'], el3.amount92);
                totalItem['item_platform']['nums95'] = NP.plus(totalItem['item_platform']['nums95'], el3.nums95);
                totalItem['item_platform']['total95'] = NP.plus(totalItem['item_platform']['total95'], el3.total95);
                totalItem['item_platform']['discount95'] = NP.plus(totalItem['item_platform']['discount95'], el3.discount95);
                totalItem['item_platform']['amount95'] = NP.plus(totalItem['item_platform']['amount95'], el3.amount95);
                totalItem['item_platform']['nums'] = NP.plus(totalItem['item_platform']['nums95'], totalItem['item_platform']['nums92'], totalItem['item_platform']['nums0']);
                totalItem['item_platform']['total'] = NP.plus(totalItem['item_platform']['total95'], totalItem['item_platform']['total92'], totalItem['item_platform']['total0']);
                totalItem['item_platform']['discount'] = NP.plus(totalItem['item_platform']['discount95'], totalItem['item_platform']['discount92'], totalItem['item_platform']['discount0']);
                totalItem['item_platform']['amount'] = NP.plus(totalItem['item_platform']['amount95'], totalItem['item_platform']['amount92'], totalItem['item_platform']['amount0']);
              });
            }
          });

          for (var i in totalItem) {
            if (i !== 'item_online' && i !== 'item_svc' && i !== 'item_cash') {
              continue;
            }

            totalItem['item_self']['nums0'] = NP.plus(totalItem['item_self']['nums0'], totalItem[i]['nums0']);
            totalItem['item_self']['nums92'] = NP.plus(totalItem['item_self']['nums92'], totalItem[i]['nums92']);
            totalItem['item_self']['nums95'] = NP.plus(totalItem['item_self']['nums95'], totalItem[i]['nums95']);
            totalItem['item_self']['total0'] = NP.plus(totalItem['item_self']['total0'], totalItem[i]['total0']);
            totalItem['item_self']['total92'] = NP.plus(totalItem['item_self']['total92'], totalItem[i]['total92']);
            totalItem['item_self']['total95'] = NP.plus(totalItem['item_self']['total95'], totalItem[i]['total95']);
            totalItem['item_self']['discount0'] = NP.plus(totalItem['item_self']['discount0'], totalItem[i]['discount0']);
            totalItem['item_self']['discount92'] = NP.plus(totalItem['item_self']['discount92'], totalItem[i]['discount92']);
            totalItem['item_self']['discount95'] = NP.plus(totalItem['item_self']['discount95'], totalItem[i]['discount95']);
            totalItem['item_self']['amount0'] = NP.plus(totalItem['item_self']['amount0'], totalItem[i]['amount0']);
            totalItem['item_self']['amount92'] = NP.plus(totalItem['item_self']['amount92'], totalItem[i]['amount92']);
            totalItem['item_self']['amount95'] = NP.plus(totalItem['item_self']['amount95'], totalItem[i]['amount95']);
            totalItem['item_self']['nums'] = NP.plus(totalItem['item_self']['nums0'], totalItem['item_self']['nums92'], totalItem['item_self']['nums95']);
            totalItem['item_self']['total'] = NP.plus(totalItem['item_self']['total0'], totalItem['item_self']['total92'], totalItem['item_self']['total95']);
            totalItem['item_self']['discount'] = NP.plus(totalItem['item_self']['discount0'], totalItem['item_self']['discount92'], totalItem['item_self']['discount95']);
            totalItem['item_self']['amount'] = NP.plus(totalItem['item_self']['amount0'], totalItem['item_self']['amount92'], totalItem['item_self']['amount95']);
          } // 处理政府价应收需减去回罐 需加上直降优惠


          for (var _i in totalItem) {
            if (totalItem[_i]['nums'] === 0) {
              delete totalItem[_i];
            }
          }

          _this7.stationMonthTotalData = Object.values(totalItem);
        }
      }).catch(function () {
        _this7.downloadLoading = false;
      });
    },
    exportExcel: function exportExcel(tableArr, excelName) {
      var _this8 = this;

      if (tableArr.length < 1) {
        _Message({
          message: '导出 sheet 为空',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      if (this.selectedStation.ID === 0) {
        _Message({
          message: '请选择对应的站点',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      if (this.sheetUnLoadCount > 0) {
        _Message({
          message: '请查询核对过后进行下载',
          type: 'error',
          duration: 5 * 1000
        });

        return;
      }

      this.downloadLoading = true;
      import('@/utils/Export2Excel').then(function (excel) {
        excel.export_table_to_excel(tableArr, _this8.selectedStation.statTag + moment(_this8.datePickerValue[0]).format('YYYY年MM月DD日') + ' ~ ' + moment(_this8.datePickerValue[1]).format('YYYY年MM月DD日') + excelName);
        _this8.downloadLoading = false;
      }).catch(function () {
        _this8.downloadLoading = false;
      });
    },
    handleDownloadBill: function handleDownloadBill(e) {
      if (this.selectedStation.ID === 0) {
        _Message({
          message: '请选择对应的站点',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      if (this.billStart < 100000 || this.billEnd < 100000) {
        _Message({
          message: '未查询到有效的交班周期',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      this.downloadBillLoading = true;
      var dataListObj = {
        page: 1,
        per: 500,
        downloadTotal: 0,
        end: 1,
        dataList: []
      };
      this.handleDownloadData(dataListObj, e);
    },
    handleDownloadData: function handleDownloadData(dataListObj, e) {
      var _this9 = this;

      var page = dataListObj.page,
          per = dataListObj.per,
          downloadTotal = dataListObj.downloadTotal,
          end = dataListObj.end,
          dataList = dataListObj.dataList; // console.log(page, per, downloadTotal, end, dataList, new Date())

      if ((page - 1) * per <= downloadTotal) {
        getBillListData(this.slotCounterName, this.selectedStation.ID, this.billStart, this.billEnd, page, per, '', 0, 0, this.beginId, moment(this.datePickerValue[1]).format('YYYYMMDD')).then(function (response) {
          var downloadStats = response.data;
          console.log('response.data', downloadStats);
          var list = downloadStats && downloadStats.list ? downloadStats.list : [];

          if (list.length > 0) {
            list.forEach(function (ele) {
              dataList.push(ele);
            });
            dataListObj.downloadTotal = downloadStats.total || 0;
            dataListObj.end = Math.ceil(downloadStats.total / per) || 1;
            _this9.beginId = downloadStats.BeginId || 0;
          }

          var reg = RegExp(/\~((\d+\.?\d*)|(\d*\.\d+))\%$/);

          if (page >= dataListObj.end) {
            e.target.innerText = e.target.innerText.replace(reg, '');
          } else {
            var percentStr = '~' + Math.floor(page * 100 / dataListObj.end) + '%'; // // console.log(e.target.innerText, reg.test(e.target.innerText), e.target.innerText.replace(reg, percentStr))

            e.target.innerText = reg.test(e.target.innerText) ? e.target.innerText.replace(reg, percentStr) : e.target.innerText + percentStr;
          }

          dataListObj.page++;
          return _this9.handleDownloadData(dataListObj, e);
        });
      } else {
        return this.billExcelExport(dataListObj.dataList);
      }
    }
  }
};